/* Generato da uploads/servizi 01 oi.html: gli SVG delle quattordici card,
   copiati come sono. Le sole differenze col modello sono di forma JSX
   (`class` → `className`, attributi in camelCase) e il prefisso `sv-` sulle
   classi interne, perché le regole che le dipingono stanno in
   app/globals.css (blocco «/servizi, i disegni») e non devono toccare
   nient'altro del sito. La griglia di fondo, identica nelle quattordici,
   è scritta una volta sola (<Griglia>), e il DOM resta quello del modello.

   I colori non sono qui: ogni classe legge i token `--oi-sv-*`, dichiarati
   sotto :root e .dark (tabella del §7 delle istruzioni). Niente
   coordinate calcolate: sono tutte letterali, quindi niente scarti fra
   Node e browser all'idratazione.

   Dal 17/10/2026 le animazioni sono in CSS (blocco «/servizi, i disegni»
   di app/globals.css) e si fermano con «riduci movimento»: lo scorrimento
   delle linee del monitoraggio era un `<animateTransform>`, che a quella
   preferenza non bada. Stessa durata e stesso tragitto (−360 in 36 s).

   `variante="domande"` dà i due disegni nuovi di /servizi «Parti dalla
   domanda» (`uploads/servizi rivisitata.html`, § 0 delle istruzioni):
   `ver2` per la Verifica informativa (da ciò che circola si risale
   all'origine) e `stu2` per gli Studi di mercato (un progetto che passa
   tre verifiche). Le istruzioni li chiedono per quella pagina e non dicono
   niente delle altre, quindi le card degli altri servizi
   (`CardServizio`, `AltriServizi`) tengono i disegni di prima. I
   quadratini che li percorrono viaggiano con `offset-path` come in
   PezziInformatica: con «riduci movimento» restano fermi all'inizio
   della loro linea. */

import type { CSSProperties, ReactNode } from "react";

function Griglia() {
  return (
    <g className="sv-gr">
      <line x1="0" y1="0" x2="0" y2="150" />
      <line x1="45" y1="0" x2="45" y2="150" />
      <line x1="90" y1="0" x2="90" y2="150" />
      <line x1="135" y1="0" x2="135" y2="150" />
      <line x1="180" y1="0" x2="180" y2="150" />
      <line x1="225" y1="0" x2="225" y2="150" />
      <line x1="270" y1="0" x2="270" y2="150" />
      <line x1="315" y1="0" x2="315" y2="150" />
      <line x1="0" y1="0" x2="360" y2="0" />
      <line x1="0" y1="37" x2="360" y2="37" />
      <line x1="0" y1="74" x2="360" y2="74" />
      <line x1="0" y1="111" x2="360" y2="111" />
      <line x1="0" y1="148" x2="360" y2="148" />
    </g>
  );
}

const DISEGNI: Record<string, { classe?: string; corpo: ReactNode }> = {
  monitoraggio: {
    classe: "sv-mon",
    corpo: (
      <>
        <Griglia />
        <g className="sv-scorre">
          <polyline className="sv-tr" points="0,36.2 14,33.6 28,39.4 42,36.5 56,30.3 67,37.8 75,36.5 83,31.1 94,38.7 105,35.4 119,32.5 133,32.2 144,31.8 155,31.6 163,31.4 177,34.4 185,30.0 193,32.1 201,39.6 209,38.7 220,33.1 228,35.4 242,36.3 250,39.4 264,32.0 275,33.0 286,34.1 294,32.6 305,33.0 319,35.9 333,36.8 344,30.7 355,38.2 366,37.0 374,34.8 388,31.8 399,39.8 407,39.5 418,38.4 426,35.5 437,33.7 451,38.4 462,30.5 470,36.2 478,31.2 486,39.3 497,33.4 508,38.9 519,37.8 527,35.9 538,38.6 546,34.3 554,32.1 568,36.1 576,33.4 590,35.5 601,36.9 612,31.8 620,36.3 634,36.9 645,31.6 653,30.8 667,35.3 678,30.3 692,35.9 703,34.6 714,31.5" />
          <polyline className="sv-tr" points="0,72.9 8,69.9 19,65.4 27,71.6 38,74.7 52,68.7 60,67.7 68,72.3 79,74.1 93,71.8 101,70.6 115,73.1 126,71.6 140,71.9 151,68.4 159,68.6 170,73.0 181,72.0 189,72.0 200,66.0 208,70.9 216,73.3 227,69.9 235,70.1 249,74.7 263,74.8 271,71.3 279,71.0 290,68.6 298,65.9 312,70.3 320,71.1 331,68.1 339,68.8 347,66.4 355,73.3 369,70.2 377,72.8 385,71.5 399,74.0 413,71.2 424,68.8 435,67.9 449,75.0 457,66.9 471,72.5 482,66.0 493,67.5 501,73.9 515,73.7 526,69.5 537,73.0 551,69.3 562,72.1 573,74.4 581,72.5 592,69.5 606,72.8 614,65.2 628,66.2 642,73.0 650,67.6 661,68.3 675,67.5 686,74.3 697,71.1 708,71.0" />
          <polyline className="sv-tr" points="0,103.2 8,103.9 16,100.7 30,100.9 44,100.6 58,102.1 66,104.3 74,102.4 88,104.2 102,101.2 110,106.3 124,109.5 138,105.9 146,109.8 154,105.6 162,102.9 170,105.4 184,103.1 198,101.8 212,105.7 220,103.7 234,107.1 248,100.6 256,105.0 270,104.3 281,104.7 292,103.6 300,107.9 314,107.8 322,105.7 336,105.0 347,107.3 358,106.1 366,101.2 377,101.6 388,101.5 399,104.2 413,100.8 427,105.7 438,103.4 449,105.9 463,108.0 471,108.4 482,104.7 496,100.6 510,107.0 524,105.8 538,108.2 549,107.2 563,103.5 574,103.6 588,101.2 596,102.2 607,101.3 615,104.0 626,100.8 637,104.0 648,108.8 659,108.6 670,107.1 681,106.8 692,109.6 700,100.8 708,102.3 716,100.1" />
          <polyline className="sv-tr" points="0,132.3 11,131.3 25,130.4 33,132.5 47,132.1 61,130.3 72,134.5 83,135.7 94,130.9 102,137.6 116,132.7 127,134.7 138,137.3 152,132.6 160,133.9 171,131.1 179,133.4 193,130.9 207,135.2 215,135.8 223,136.1 237,139.5 248,137.0 256,139.5 270,134.6 284,138.8 295,135.6 306,131.3 320,131.0 334,133.1 345,139.5 356,135.0 364,133.1 375,135.3 389,136.6 403,139.1 417,132.2 425,139.1 436,133.4 447,130.3 458,133.8 472,138.9 480,136.6 488,131.7 502,138.5 510,132.0 518,133.0 526,138.0 537,133.4 545,135.7 553,131.4 567,134.5 578,130.8 586,132.9 594,130.3 608,131.1 622,135.3 630,138.1 644,134.9 652,139.8 660,131.9 668,133.4 682,135.7 696,133.0 707,139.6 715,136.5" />
          <g className="sv-ev">
            <circle cx="90" cy="35" r="7" />
            <rect className="sv-r" x="87.0" y="32.0" width="6" height="6" />
          </g>
          <g className="sv-ev">
            <circle cx="200" cy="70" r="7" />
            <rect className="sv-r" x="197.0" y="67.0" width="6" height="6" />
          </g>
          <g className="sv-ev">
            <circle cx="300" cy="105" r="7" />
            <rect className="sv-r" x="297.0" y="102.0" width="6" height="6" />
          </g>
          <g className="sv-ev">
            <circle cx="450" cy="135" r="7" />
            <rect className="sv-r" x="447.0" y="132.0" width="6" height="6" />
          </g>
          <g className="sv-ev">
            <circle cx="520" cy="35" r="7" />
            <rect className="sv-r" x="517.0" y="32.0" width="6" height="6" />
          </g>
          <g className="sv-ev">
            <circle cx="610" cy="70" r="7" />
            <rect className="sv-r" x="607.0" y="67.0" width="6" height="6" />
          </g>
        </g>
        <text className="sv-lb" x="10" y="27">ENERGIA</text>
        <text className="sv-lb" x="10" y="62">FINANZA</text>
        <text className="sv-lb" x="10" y="97">LOGISTICA</text>
        <line className="sv-oggi" x1="270" y1="8" x2="270" y2="146" />
        <text className="sv-lb sv-r" x="276" y="16">OGGI</text>
      </>
    ),
  },
  report: {
    corpo: (
      <>
        <Griglia />
        <path className="sv-p1" d="M90 30 L200 18 L185 125 L105 135Z" />
        <path className="sv-p2" d="M150 50 L280 35 L262 120 L140 128Z" />
        <path className="sv-p3" d="M200 80 L320 92 L300 140 L210 132Z" />
        <polyline className="sv-ln" points="40,40 120,60 210,52 300,70" />
        <polyline className="sv-ln2" points="60,120 150,90 240,108 320,96" />
        <rect className="sv-a" x="36.5" y="36.5" width="7" height="7" />
        <rect className="sv-r" x="116.5" y="56.5" width="7" height="7" />
        <rect className="sv-a" x="206.5" y="48.5" width="7" height="7" />
        <rect className="sv-r" x="296.5" y="66.5" width="7" height="7" />
        <rect className="sv-a" x="56.5" y="116.5" width="7" height="7" />
        <rect className="sv-a" x="146.5" y="86.5" width="7" height="7" />
        <rect className="sv-r" x="236.5" y="104.5" width="7" height="7" />
        <rect className="sv-a" x="316.5" y="92.5" width="7" height="7" />
        <text className="sv-lb" x="40" y="28">ATTORI</text>
        <text className="sv-lb" x="270" y="144">INTERESSI</text>
      </>
    ),
  },
  "verifica-informativa": {
    corpo: (
      <>
        <Griglia />
        <g className="sv-doc">
          <rect x="70" y="30" width="110" height="100" />
          <rect x="88" y="20" width="110" height="100" />
          <rect x="106" y="10" width="110" height="100" />
        </g>
        <line className="sv-tx" x1="118" y1="30" x2="200" y2="30" />
        <line className="sv-tx" x1="118" y1="42" x2="180" y2="42" />
        <line className="sv-tx" x1="118" y1="54" x2="160" y2="54" />
        <line className="sv-tx" x1="118" y1="66" x2="200" y2="66" />
        <line className="sv-tx" x1="118" y1="78" x2="180" y2="78" />
        <line className="sv-tx" x1="118" y1="90" x2="160" y2="90" />
        <g className="sv-ok">
          <path d="M206 42 l5 5 l9 -10" />
          <path d="M206 66 l5 5 l9 -10" />
        </g>
        <path className="sv-no" d="M207 86 l10 10 M217 86 l-10 10" />
        <circle className="sv-lens" cx="260" cy="88" r="34" />
        <line className="sv-lens" x1="284" y1="112" x2="310" y2="138" />
        <text className="sv-lb" x="236" y="144">FONTI</text>
      </>
    ),
  },
  analisi: {
    corpo: (
      <>
        <Griglia />
        <rect className="sv-bar" x="40" y="110" width="22" height="30" />
        <rect className="sv-bar" x="82" y="96" width="22" height="44" />
        <rect className="sv-bar" x="124" y="102" width="22" height="38" />
        <rect className="sv-bar" x="166" y="80" width="22" height="60" />
        <rect className="sv-bar" x="208" y="68" width="22" height="72" />
        <rect className="sv-bar" x="250" y="74" width="22" height="66" />
        <rect className="sv-bar" x="292" y="50" width="22" height="90" />
        <polyline className="sv-cv" points="51,104 93,92 135,96 177,74 219,60 261,62 303,36" />
        <g className="sv-flag">
          <line x1="303" y1="36" x2="303" y2="12" />
          <path d="M303 12 L326 17 L303 22Z" />
        </g>
        <text className="sv-lb" x="40" y="20">FATTIBILITÀ</text>
      </>
    ),
  },
  "presenza-internazionale": {
    corpo: (
      <>
        <Griglia />
        <path className="sv-cs" d="M40 110 C90 60 140 40 200 46 S300 30 330 20" />
        <path className="sv-cs" d="M40 110 C120 120 200 100 320 120" />
        <path className="sv-cs" d="M40 110 C110 90 180 80 250 76" />
        <rect className="sv-r" x="34.0" y="104.0" width="12" height="12" />
        <rect className="sv-a" x="326.5" y="16.5" width="7" height="7" />
        <rect className="sv-a" x="316.5" y="116.5" width="7" height="7" />
        <rect className="sv-a" x="246.5" y="72.5" width="7" height="7" />
        <text className="sv-lb sv-r" x="26" y="136">ITALIA</text>
        <text className="sv-lb" x="286" y="14">MERCATO A</text>
        <text className="sv-lb" x="270" y="140">MERCATO B</text>
        <text className="sv-lb" x="220" y="68">MERCATO C</text>
      </>
    ),
  },
  "import-export": {
    corpo: (
      <>
        <Griglia />
        <rect className="sv-pt" x="30" y="50" width="70" height="50" />
        <rect className="sv-pt" x="260" y="50" width="70" height="50" />
        <rect className="sv-ct" x="40" y="62" width="12" height="10" />
        <rect className="sv-ct" x="40" y="78" width="12" height="10" />
        <rect className="sv-ct" x="56" y="62" width="12" height="10" />
        <rect className="sv-ct" x="56" y="78" width="12" height="10" />
        <rect className="sv-ct" x="72" y="62" width="12" height="10" />
        <rect className="sv-ct" x="72" y="78" width="12" height="10" />
        <rect className="sv-ct" x="270" y="62" width="12" height="10" />
        <rect className="sv-ct" x="270" y="78" width="12" height="10" />
        <rect className="sv-ct" x="286" y="62" width="12" height="10" />
        <rect className="sv-ct" x="286" y="78" width="12" height="10" />
        <rect className="sv-ct" x="302" y="62" width="12" height="10" />
        <rect className="sv-ct" x="302" y="78" width="12" height="10" />
        <path className="sv-ln" d="M105 64 H255" />
        <path className="sv-ln2" d="M255 88 H105" />
        <path className="sv-ah" d="M248 59 l8 5 l-8 5Z" />
        <path className="sv-ahw" d="M112 83 l-8 5 l8 5Z" />
        <text className="sv-lb" x="30" y="40">EXPORT</text>
        <text className="sv-lb" x="260" y="40">IMPORT</text>
        <text className="sv-lb" x="150" y="120">PARTNER · COSTI · CONDIZIONI</text>
      </>
    ),
  },
  "materie-prime": {
    corpo: (
      <>
        <Griglia />
        <path className="sv-st0" d="M0 60 C90 50 180 72 360 56 L360 150 L0 150Z" />
        <path className="sv-st1" d="M0 80 C90 70 180 92 360 76 L360 150 L0 150Z" />
        <path className="sv-st2" d="M0 100 C90 90 180 112 360 96 L360 150 L0 150Z" />
        <path className="sv-st0" d="M0 120 C90 110 180 132 360 116 L360 150 L0 150Z" />
        <path className="sv-ore" d="M70 92 l7 -4 l7 4 v8 l-7 4 l-7 -4Z" />
        <path className="sv-ore" d="M160 108 l7 -4 l7 4 v8 l-7 4 l-7 -4Z" />
        <path className="sv-ore" d="M250 98 l7 -4 l7 4 v8 l-7 4 l-7 -4Z" />
        <path className="sv-ore" d="M300 124 l7 -4 l7 4 v8 l-7 4 l-7 -4Z" />
        <path className="sv-ln" d="M77 96 C120 40 220 30 330 26" />
        <rect className="sv-r" x="325.0" y="21.0" width="10" height="10" />
        <text className="sv-lb" x="250" y="18">FORNITORE</text>
      </>
    ),
  },
  "due-diligence": {
    corpo: (
      <>
        <Griglia />
        <path className="sv-ln2" d="M180 22 V50 M100 50 H260 M100 50 V78 M180 50 V78 M260 50 V78 M60 106 H140 M60 106 V96 M140 106 V96 M100 78 V106" />
        <rect className="sv-a" x="174.0" y="16.0" width="12" height="12" />
        <rect className="sv-a" x="95.0" y="77.0" width="10" height="10" />
        <rect className="sv-r" x="175.0" y="77.0" width="10" height="10" />
        <rect className="sv-a" x="255.0" y="77.0" width="10" height="10" />
        <rect className="sv-a" x="56.0" y="92.0" width="8" height="8" />
        <rect className="sv-a" x="136.0" y="92.0" width="8" height="8" />
        <circle className="sv-lens" cx="180" cy="82" r="22" />
        <line className="sv-lens" x1="196" y1="98" x2="214" y2="118" />
        <text className="sv-lb" x="196" y="28">TITOLARE EFFETTIVO</text>
      </>
    ),
  },
  "rischio-reputazionale": {
    corpo: (
      <>
        <Griglia />
        <line className="sv-ln2" x1="60" y1="40" x2="140" y2="70" />
        <line className="sv-ln2" x1="140" y1="70" x2="220" y2="40" />
        <line className="sv-ln2" x1="140" y1="70" x2="180" y2="110" />
        <line className="sv-ln2" x1="220" y1="40" x2="300" y2="70" />
        <line className="sv-ln2" x1="180" y1="110" x2="300" y2="70" />
        <line className="sv-ln2" x1="60" y1="40" x2="80" y2="110" />
        <line className="sv-ln2" x1="80" y1="110" x2="180" y2="110" />
        <path className="sv-bb" d="M46 30 h28 v16 h-18 l-6 6 v-6 h-4Z" />
        <path className="sv-bb" d="M206 30 h28 v16 h-18 l-6 6 v-6 h-4Z" />
        <path className="sv-bb" d="M66 100 h28 v16 h-18 l-6 6 v-6 h-4Z" />
        <path className="sv-bb" d="M286 60 h28 v16 h-18 l-6 6 v-6 h-4Z" />
        <path className="sv-wr" d="M140 56 L156 84 H124Z" />
        <line className="sv-wrl" x1="140" y1="66" x2="140" y2="76" />
        <rect className="sv-r" x="176.5" y="106.5" width="7" height="7" />
      </>
    ),
  },
  sanzioni: {
    corpo: (
      <>
        <Griglia />
        <rect className="sv-r" x="54.0" y="24.0" width="12" height="12" />
        <rect className="sv-a" x="54.0" y="60.0" width="12" height="12" />
        <rect className="sv-a" x="54.0" y="96.0" width="12" height="12" />
        <rect className="sv-a" x="94.0" y="24.0" width="12" height="12" />
        <rect className="sv-a" x="94.0" y="60.0" width="12" height="12" />
        <rect className="sv-r" x="94.0" y="96.0" width="12" height="12" />
        <rect className="sv-a" x="134.0" y="24.0" width="12" height="12" />
        <rect className="sv-r" x="134.0" y="60.0" width="12" height="12" />
        <rect className="sv-a" x="134.0" y="96.0" width="12" height="12" />
        <rect className="sv-r" x="174.0" y="24.0" width="12" height="12" />
        <rect className="sv-a" x="174.0" y="60.0" width="12" height="12" />
        <rect className="sv-a" x="174.0" y="96.0" width="12" height="12" />
        <rect className="sv-a" x="214.0" y="24.0" width="12" height="12" />
        <rect className="sv-a" x="214.0" y="60.0" width="12" height="12" />
        <rect className="sv-r" x="214.0" y="96.0" width="12" height="12" />
        <rect className="sv-a" x="254.0" y="24.0" width="12" height="12" />
        <rect className="sv-r" x="254.0" y="60.0" width="12" height="12" />
        <rect className="sv-a" x="254.0" y="96.0" width="12" height="12" />
        <rect className="sv-r" x="294.0" y="24.0" width="12" height="12" />
        <rect className="sv-a" x="294.0" y="60.0" width="12" height="12" />
        <rect className="sv-a" x="294.0" y="96.0" width="12" height="12" />
        <path className="sv-no" d="M134 24 l12 12 M146 24 l-12 12" />
        <path className="sv-no" d="M254 60 l12 12 M266 60 l-12 12" />
        <path className="sv-no" d="M94 96 l12 12 M106 96 l-12 12" />
        <path className="sv-no" d="M214 96 l12 12 M226 96 l-12 12" />
        <line className="sv-bar2" x1="20" y1="136" x2="340" y2="136" />
        <line className="sv-bar3" x1="30" y1="136" x2="40" y2="126" />
        <line className="sv-bar3" x1="54" y1="136" x2="64" y2="126" />
        <line className="sv-bar3" x1="78" y1="136" x2="88" y2="126" />
        <line className="sv-bar3" x1="102" y1="136" x2="112" y2="126" />
        <line className="sv-bar3" x1="126" y1="136" x2="136" y2="126" />
        <line className="sv-bar3" x1="150" y1="136" x2="160" y2="126" />
        <line className="sv-bar3" x1="174" y1="136" x2="184" y2="126" />
        <line className="sv-bar3" x1="198" y1="136" x2="208" y2="126" />
        <line className="sv-bar3" x1="222" y1="136" x2="232" y2="126" />
        <line className="sv-bar3" x1="246" y1="136" x2="256" y2="126" />
        <line className="sv-bar3" x1="270" y1="136" x2="280" y2="126" />
        <line className="sv-bar3" x1="294" y1="136" x2="304" y2="126" />
        <line className="sv-bar3" x1="318" y1="136" x2="328" y2="126" />
      </>
    ),
  },
  "cibernetica-aziendale": {
    corpo: (
      <>
        <Griglia />
        <circle className="sv-loop" cx="180" cy="78" r="52" />
        <path className="sv-ah" d="M228 60 l6 10 l-11 1Z" />
        <path className="sv-ah" d="M150 125 l-11 -2 l7 -9Z" />
        <path className="sv-ah" d="M140 44 l2 -11 l8 8Z" />
        <rect className="sv-a" x="174.0" y="20.0" width="12" height="12" />
        <rect className="sv-r" x="220.0" y="98.0" width="12" height="12" />
        <rect className="sv-a" x="128.0" y="98.0" width="12" height="12" />
        <text className="sv-lb" x="196" y="24">INFORMAZIONI</text>
        <text className="sv-lb" x="238" y="122">DECISIONI</text>
        <text className="sv-lb" x="64" y="122">PROCESSI</text>
      </>
    ),
  },
  informatica: {
    corpo: (
      <>
        <Griglia />
        <rect className="sv-chip" x="150" y="50" width="60" height="50" />
        <line className="sv-pin" x1="160" y1="44" x2="160" y2="50" />
        <line className="sv-pin" x1="160" y1="100" x2="160" y2="106" />
        <line className="sv-pin" x1="170" y1="44" x2="170" y2="50" />
        <line className="sv-pin" x1="170" y1="100" x2="170" y2="106" />
        <line className="sv-pin" x1="180" y1="44" x2="180" y2="50" />
        <line className="sv-pin" x1="180" y1="100" x2="180" y2="106" />
        <line className="sv-pin" x1="190" y1="44" x2="190" y2="50" />
        <line className="sv-pin" x1="190" y1="100" x2="190" y2="106" />
        <line className="sv-pin" x1="200" y1="44" x2="200" y2="50" />
        <line className="sv-pin" x1="200" y1="100" x2="200" y2="106" />
        <path className="sv-ci" d="M150 64 H90 V30 H30 M150 86 H110 V120 H40 M210 64 H260 V30 H330 M210 86 H280 V124 H330" />
        <rect className="sv-a" x="26.5" y="26.5" width="7" height="7" />
        <rect className="sv-r" x="36.5" y="116.5" width="7" height="7" />
        <rect className="sv-r" x="326.5" y="26.5" width="7" height="7" />
        <rect className="sv-a" x="326.5" y="120.5" width="7" height="7" />
        <text className="sv-lb" x="162" y="80">DATI</text>
      </>
    ),
  },
  giuridico: {
    corpo: (
      <>
        <Griglia />
        <rect className="sv-pg" x="110" y="14" width="140" height="124" />
        <line className="sv-tx" x1="126" y1="32" x2="234" y2="32" />
        <line className="sv-tx" x1="126" y1="43" x2="204" y2="43" />
        <line className="sv-tx" x1="126" y1="54" x2="234" y2="54" />
        <line className="sv-tx" x1="126" y1="65" x2="204" y2="65" />
        <line className="sv-tx" x1="126" y1="76" x2="234" y2="76" />
        <line className="sv-tx" x1="126" y1="87" x2="204" y2="87" />
        <line className="sv-tx" x1="126" y1="98" x2="234" y2="98" />
        <path className="sv-sig" d="M128 120 c10 -14 18 6 26 -4 s12 -10 22 0" />
        <circle className="sv-seal" cx="224" cy="114" r="18" />
        <circle className="sv-seal" cx="224" cy="114" r="12" />
        <text className="sv-lb" x="40" y="40">CONTRATTI</text>
        <text className="sv-lb" x="268" y="70">CONFORMITÀ</text>
        <text className="sv-lb" x="40" y="120">CONTENZIOSO</text>
      </>
    ),
  },
  "pianificazione-strategica": {
    corpo: (
      <>
        <Griglia />
        <line className="sv-ln2" x1="30" y1="96" x2="330" y2="96" />
        <path className="sv-dm" d="M50 88 l8 8 l-8 8 l-8 -8Z" />
        <path className="sv-dm" d="M120 88 l8 8 l-8 8 l-8 -8Z" />
        <path className="sv-dm" d="M190 88 l8 8 l-8 8 l-8 -8Z" />
        <path className="sv-dm" d="M260 88 l8 8 l-8 8 l-8 -8Z" />
        <path className="sv-dm sv-r" d="M320 88 l8 8 l-8 8 l-8 -8Z" />
        <polyline className="sv-cv" points="50,70 120,62 190,50 260,40 320,24" />
        <g className="sv-flag">
          <line x1="320" y1="24" x2="320" y2="4" />
          <path d="M320 4 L340 9 L320 14Z" />
        </g>
        <text className="sv-lb" x="36" y="124">ANALISI</text>
        <text className="sv-lb" x="160" y="124">ELABORAZIONE</text>
        <text className="sv-lb sv-r" x="270" y="124">OBIETTIVO</text>
      </>
    ),
  },
};

/** Il tragitto del quadratino rame, scritto una volta sola. */
function Corsa({ percorso }: { percorso: string }) {
  return (
    <rect
      className="sv-mv"
      x="-4"
      y="-4"
      width="8"
      height="8"
      style={{ offsetPath: `path("${percorso}")` } as CSSProperties}
    />
  );
}

/** I disegni nuovi di /servizi «Parti dalla domanda», copiati dal modello. */
const DISEGNI_DOMANDE: Record<string, { classe?: string; corpo: ReactNode }> = {
  "verifica-informativa": {
    classe: "sv-ver2",
    corpo: (
      <>
        <Griglia />
        <path className="sv-vin" d="M300 34 L262 72" />
        <rect className="sv-vs" x="296" y="30" width="8" height="8" />
        <path className="sv-vin" d="M318 62 L262 72" />
        <rect className="sv-vs" x="314" y="58" width="8" height="8" />
        <path className="sv-vin" d="M304 92 L262 72" />
        <rect className="sv-vs" x="300" y="88" width="8" height="8" />
        <path className="sv-vin" d="M326 118 L262 72" />
        <rect className="sv-vs" x="322" y="114" width="8" height="8" />
        <text className="sv-lb" x="352" y="16" textAnchor="end">CIÒ CHE CIRCOLA</text>
        <rect className="sv-vc" x="246" y="62" width="20" height="20" />
        <path className="sv-vback" d="M246 72 H200 L170 48 H120 L92 72 H52" />
        <path className="sv-vside" d="M170 48 L150 22" />
        <path className="sv-vside" d="M200 72 L176 104" />
        <path className="sv-no" d="M145 17 l10 10 M155 17 l-10 10" />
        <path className="sv-no" d="M171 99 l10 10 M181 99 l-10 10" />
        <circle className="sv-vn" cx="200" cy="72" r="4" />
        <circle className="sv-vn" cx="170" cy="48" r="4" />
        <circle className="sv-vn" cx="120" cy="48" r="4" />
        <circle className="sv-vn" cx="92" cy="72" r="4" />
        <rect className="sv-vo" x="30" y="61" width="22" height="22" />
        <text className="sv-lb sv-r" x="41" y="98" textAnchor="middle">ORIGINE</text>
        <Corsa percorso="M246 72 H200 L170 48 H120 L92 72 H52" />
        <rect className="sv-ve1" x="24" y="124" width="8" height="8" />
        <text className="sv-lb sv-r" x="37" y="131">CONFERMATO</text>
        <rect className="sv-ve0" x="110" y="124" width="8" height="8" />
        <text className="sv-lb" x="123" y="131">SMENTITO</text>
        <rect className="sv-ve0" x="196" y="124" width="8" height="8" />
        <text className="sv-lb" x="209" y="131">INCERTO</text>
      </>
    ),
  },
  analisi: {
    classe: "sv-stu2",
    corpo: (
      <>
        <Griglia />
        <line className="sv-gtl" x1="123" y1="22" x2="123" y2="132" />
        <rect className="sv-gt" x="118" y="56" width="10" height="14" />
        <rect className="sv-gt" x="118" y="86" width="10" height="14" />
        <text className="sv-lb" x="123" y="16" textAnchor="middle">MERCATO</text>
        <line className="sv-gtl" x1="193" y1="22" x2="193" y2="132" />
        <rect className="sv-gt" x="188" y="56" width="10" height="14" />
        <rect className="sv-gt" x="188" y="86" width="10" height="14" />
        <text className="sv-lb" x="193" y="16" textAnchor="middle">COSTI</text>
        <line className="sv-gtl" x1="263" y1="22" x2="263" y2="132" />
        <rect className="sv-gt" x="258" y="56" width="10" height="14" />
        <rect className="sv-gt" x="258" y="86" width="10" height="14" />
        <text className="sv-lb" x="263" y="16" textAnchor="middle">RISCHI</text>
        <path className="sv-pth" d="M40 78 H118 M128 78 H188 M198 78 H258 M268 78 C290 78 300 60 322 52" />
        <path className="sv-pth2" d="M198 78 C220 78 230 112 270 120 H300" />
        <rect className="sv-pj" x="28" y="66" width="24" height="24" />
        <text className="sv-lb" x="40" y="108" textAnchor="middle">PROGETTO</text>
        <rect className="sv-alt" x="300" y="114" width="12" height="12" />
        <text className="sv-lb" x="288" y="142" textAnchor="middle">DA RIVEDERE</text>
        <g className="sv-flag">
          <line x1="322" y1="52" x2="322" y2="26" />
          <path d="M322 26 L342 31 L322 36Z" />
        </g>
        <text className="sv-lb sv-r" x="322" y="82" textAnchor="middle">FATTIBILE</text>
        <Corsa percorso="M40 78 H268 C290 78 300 60 322 52" />
      </>
    ),
  },
};

/** Il disegno 360 × 150 in testa alla card del servizio, largo tutta la
 *  card. Fondo `--oi-sv-fondo` e la leggera desaturazione del modello
 *  (`saturate(.8)`). Decorativo: il titolo della card dice già che cos'è. */
export function DisegnoServizio({ slug, variante }: { slug: string; variante?: "domande" }) {
  const d = (variante === "domande" ? DISEGNI_DOMANDE[slug] : undefined) ?? DISEGNI[slug];
  if (!d) return null;
  return (
    <svg
      viewBox="0 0 360 150"
      aria-hidden
      className={`oi-sv-disegno block h-auto w-full bg-[var(--oi-sv-fondo)] saturate-[.8] ${d.classe ?? ""}`}
    >
      {d.corpo}
    </svg>
  );
}
